import { CloudCommand } from "../types.js";

export const editMessage: CloudCommand = {
    action: "MESSAGE/EDIT",
    commandName: "message.editMessage",
    buildPayload: ({ params }) => params,
};
